module.exports = __webpack_public_path__ + "img/room_3.82f7a262.jpg";